import type { IconConfig } from '../../utils'

/**
 * Used to determine the render-style of image choices
 */
export enum IMAGE_CHOICE_UI_SUBTYPE {
  INFOGRAPHIC = 'infographic',
  ICON = 'icon'
}

export interface Choice {
  /**
   * Raw value of a given choice, can be a string or number
   */
  value: string
  /**
   * Human-friendly label
   */
  label?: string | null
  /**
   * An icon to help convey what this choice is about
   */
  icon?: IconConfig
}

export interface IconChoice extends Choice {
  /**
   * The icon URL on image choices
   */
  image?: string
}

export interface InfographicChoice extends Choice {
  /**
   * The image URL on image choices
   */
  image?: string
  /**
   * This is the description of the image, which is used as alt text for the image
   */
  imageDescription?: string
}

export type ImageChoice = IconChoice | InfographicChoice

export enum BUTTON_CHOICE_LAYOUT_TYPE {
  ROW = 'row',
  STACK = 'stack',
  CHIP = 'chip'
}
